<app-authview-header/>

<div [style.background-image]="backgroundImage? 'url(' + backgroundImage + ')' : ''" class="minFullHeight"
     [class.hijacked]="this.user?.hijacked">
    <div class="mx-auto">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
</div>
@defer () {
    <app-footer></app-footer>
}